import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1586171a&"
var script = {}


/* normalize component */
import normalizer from "!../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports